export default __webpack_public_path__ + "static/10-982f6e95987c6d7aee9246ef892be0e5.png";